import React, { useState, useEffect } from "react";
import { trackPromise } from "react-promise-tracker";
import {
  detalhesUsuario,
  editarUsuario,
  listarPermissoes,
} from "../../../services/http/usuariosService";

import {
  Avatar,
  Divider,
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  message,
} from "antd";
import ModalConfirmar from "../../../components/ModalConfirmar";
import "./styles.scss";

const FormUsuario = ({ id, listarUsuarios }) => {
  const [form] = Form.useForm();
  const [usuario, setUsuario] = useState({});
  const [permissoes, setPermissoes] = useState([]);
  const [pemissoesUsuario, setPermissoesUsuario] = useState([]);
  const [detalhe, setDetalhe] = useState(false);
  const [confirmarModal, setConfirmarModal] = useState(false);
  const [checkAntes, setCheckAntes] = useState([]);
  const [checkDepois, setCheckDepois] = useState([]);
  const [modificar, setModificar] = useState(false);

  const showIniciais = (nome) => {
    let nomecompleto = nome.replace(".", " "); // Remove os de,da, dos,das.
    var iniciais = nomecompleto.match(/\b(\w)/gi); // Iniciais de cada parte do nome.
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase(); // Iniciais
    return sobrenomes;
  };

  useEffect(() => {
    form.resetFields();
    buscarDetalhes(id);
  }, [id]);

  useEffect(() => {
    listaPermissoes();
    montarPermissoes();
    iniciarValoresForm();
    setDetalhe(false);
  }, [detalhe]);

  useEffect(() => {
    setCheckDepois(pemissoesUsuario);
  }, [pemissoesUsuario]);

  useEffect(() => {
    if (modificar) {
      onSubmit(form.getFieldsValue());
    }
  }, [modificar]);

  const buscarDetalhes = (id) => {
    trackPromise(
      detalhesUsuario(id)
        .then((res) => {
          if (!res.fail && res.data) {
            setUsuario(res.data);
            setCheckAntes(res.data.permissoes);
            setDetalhe(true);
            setModificar(false);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const atualizarUsuario = (values, usuarioPermissoes) => {
    let data = {
      id: usuario.id,
      email: values.email,
      login: values.login,
      nivelAcesso: values.nivelAcesso,
    };

    let arrayPermissoes = [];

    usuarioPermissoes.forEach((element) => {
      if (element.id != "todos" && element.checked) {
        arrayPermissoes.push({
          id: element.id,
          permissao: element.permissao,
        });
      }
    });

    data.permissoes = arrayPermissoes;

    trackPromise(
      editarUsuario(data).then((res) => {
        if (!res.fail) {
          message.success("Usuário atualizado com sucesso");
          listarUsuarios();
          buscarDetalhes(id);
        } else {
          message.error(res.errors.message);
        }
      })
    );
  };

  const listaPermissoes = () => {
    trackPromise(
      listarPermissoes()
        .then((res) => {
          if (!res.fail && res.data) {
            setPermissoes(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const montarPermissoes = () => {
    let novaListaPermissoes = permissoes.map((element) => {
      let permSelecionada = usuario.permissoes.find(
        (p) => p.id === element.id
      );

      return {
        id: element.id,
        permissao: element.permissao,
        checked: permSelecionada ? true : false,
      };
    });
    setPermissoesUsuario(novaListaPermissoes);
  };

  const iniciarValoresForm = () => {
    if (usuario?.id != null) {
      form.setFieldsValue({
        nome: usuario.nome,
        login: usuario.login,
        email: usuario.email,
        nivelAcesso: usuario.nivelAcesso,
      });
    }
  };

  const onSubmit = (values) => {
    atualizarUsuario(values, pemissoesUsuario);
  };

  const handleCheckedPermissoes = (item, checked) => {
    if (item == "todos") {
      var arrayMap = pemissoesUsuario.map((item) => {
        return {
          id: item.id,
          permissao: item.permissao,
          checked: checked,
        };
      });
      setPermissoesUsuario(arrayMap);
    } else {
      let permissao = pemissoesUsuario.find((p) => p.id == item);
      permissao.checked = checked;
      let indexPermissao = pemissoesUsuario.findIndex((p) => p.id == item);

      if (indexPermissao >= 0) {
        pemissoesUsuario[indexPermissao] = permissao;

        var arrayMap = pemissoesUsuario.map((item) => {
          return item;
        });
        setPermissoesUsuario(arrayMap);
      }
    }
  };

  const showAvatar = () => {
    if (usuario.login) {
      return (
        <Row justify="start">
          <Col span={12}>
            <Avatar style={{ background: "#0042DD", color: "#FFFFFF" }}>
              {showIniciais(usuario.login)}
            </Avatar>
            <span className="span-nome-login"> {usuario.login} </span>
          </Col>
        </Row>
      );
    }
  };

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 ml-2">
      {showAvatar()}

      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12  p-0">
          <Divider style={{ background: "#9E9E9E" }} />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 p-0  mb-4">
          <span className="span-title">Dados Cadastrais</span>
        </div>
      </div>

      <Form form={form} layout="vertical">
        <div className="row ">
          <div className="col-lg-5 col-md-5 col-sm-12 p-0">
            <Form.Item
              className="label-usuario"
              label="Login"
              name="login"
              disabled
            >
              <Input disabled className="input-usuario" />
            </Form.Item>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 ">
            <Form.Item
              className="label-usuario"
              label="E-mail"
              name="email"
              disabled
            >
              <Input disabled className="input-usuario" />
            </Form.Item>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-5 col-md-12 col-sm-12 p-0">
            <Form.Item
              className="label-usuario"
              label="Nivel de acesso"
              name="nivelAcesso"
              disabled
            >
              <Input disabled className="input-usuario" />
            </Form.Item>
          </div>
        </div>

        <div className="row">
          <span className="span-title  mb-3">Permissões de visualização</span>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="m-0 p-0">
              <Checkbox
                defaultChecked={false}
                onChange={(e) =>
                  handleCheckedPermissoes("todos", e.target.checked)
                }
              >
                Todos
              </Checkbox>
            </div>
          </div>
          <div className="col-md-9 divOrdenarUsuarios list-container-horizontal">
            {pemissoesUsuario &&
              pemissoesUsuario.map((item, index) => (
                <div key={item.id} span={6}>
                  <div className="m-0 p-0 ordenarUsuario">
                    <Checkbox
                      type="checkbox"
                      checked={item.checked}
                      onChange={(e) =>
                        handleCheckedPermissoes(`${item.id}`, e.target.checked)
                      }
                    >
                      {item.permissao}
                    </Checkbox>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2 w-100">
          <Form.Item>
            <button
              className="btn-aplicarNotForm px-5"
              onClick={() => setConfirmarModal(true)}
            >
              APLICAR
            </button>
          </Form.Item>
        </div>
      </Form>

      {confirmarModal && (
        <ModalConfirmar
          segundoModal={confirmarModal}
          setSegundoModal={setConfirmarModal}
          checkAntes={checkAntes}
          checkDepois={checkDepois}
          setModificar={setModificar}
        />
      )}
    </div>
  );
};

export default FormUsuario;
